import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';
import { urlParamsService } from 'ui/components/Explore/services/url-params.service';

export const exploreRedirections: RedirectionStateObject = {
  'dashboard.explore': params => {
    const { columns: oldColumns, query: oldQuery, ...rest } = params || {};
    const columns = oldColumns && urlParamsService.urlParamToColumns(oldColumns);
    const query = oldQuery && urlParamsService.urlParamToFilters(oldQuery);

    const search = tanstackUrlSearch({ query, columns, ...rest });

    return `/360/explore${search}`;
  },
  'dashboard.explore-context': params => `/360/explore${tanstackUrlSearch(params)}`,
  'dashboard.log': params => {
    const { logId, ...rest } = params || {};

    if (!logId) return `/360/explore`;

    return `/360/explore/log/${uriSafe(logId)}${tanstackUrlSearch(rest)}`;
  },
  'dashboard.explore-preferences': () => `/360/explore/preferences`,
  'view-investigate-explore-alert': params => {
    const { triggeredId, switchToAccountId } = params || {};

    if (!triggeredId) return '/360/explore';

    const searchParams = {
      triggeredId,
      ...(switchToAccountId && { switchToAccountId }),
    };

    return `/360/view-investigate-alert${tanstackUrlSearch(searchParams)}`;
  },
};
